<template>
  <div class="contact">
    <div class='container'>
      <h1>Locate Us</h1>
      <h5 />
    </div>
    <div class='content container'>
      <div>
        <iframe 
          height="500" 
          id="gmap_canvas" 
          src="https://maps.google.com/maps?q=%2013%20E%20Kossuth%20St,%20Columbus,%20OH%2043206&t=&z=19&ie=UTF8&iwloc=&output=embed" 
          frameborder="0" 
          scrolling="no" 
          marginheight="0" 
          marginwidth="0">
        </iframe>
        <div>
          Our office can be found at 13 E Kossuth St, Columbus, OH 43206, just between South High Street and South Pearl Street. Street parking is available to assist in your arrival.
        </div>
      </div>
      <div>
        <div>
          <Contact />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Contact from '@/components/contact.vue'
export default {
  name: 'ContactUs',
  components: { 
    Contact
  }
}
</script>

<style scoped lang='scss'>
iframe {
  width: 100%;
}

.contact {
  padding-bottom: 50px;
  h1 {
    font-family: "Merriweather", serif;
    margin-bottom: 10px;
  }

  h5 {
    margin: 0px;
    padding-bottom: 10px;
    font-weight: 300;
    color: #d5d5d5;
    border-bottom: 1px solid #d5d5d5;
  }

  img {
    float: left;
    margin-right: 20px;
    margin-bottom: 20px;
    border-radius: 5px;
  }

  .content {
    margin-top: 20px;
    display: grid;
    grid-template-columns: 2fr 1fr;


    div:nth-child(1) {
      line-height: 1.5em;
      font-size: 15px;
      padding-right: 25px;
      text-align: justify;

      a:not(.btn) {
        font-weight: bold;
        color: #494949;
        text-decoration: none;

        &:hover {
          color: #26bac5;
        }
      }

      div.cta {
        margin-top: 25px;
      }
    }

    div:nth-child(2) {
      div {
        border-radius: 5px;
        background-color: #2F3439;
        padding: 15px;
      }
    }
  }
}

</style>
